/**
 * Session manager — centralizes session ID storage.
 * Uses sessionStorage (cleared on tab close) to reduce XSS attack surface
 * compared to localStorage. Falls back to localStorage for backward compat
 * with existing sessions.
 */

const SESSION_KEY = 'le_session_id';

export function getSessionId() {
  try {
    return sessionStorage.getItem(SESSION_KEY) || localStorage.getItem(SESSION_KEY) || null;
  } catch (_) {
    return null;
  }
}

export function setSessionId(id) {
  try { sessionStorage.setItem(SESSION_KEY, id); } catch (_) { /* noop */ }
  try { localStorage.setItem(SESSION_KEY, id); } catch (_) { /* noop */ }
}

export function clearSession() {
  try { sessionStorage.removeItem(SESSION_KEY); } catch (_) { /* noop */ }
  try { localStorage.removeItem(SESSION_KEY); } catch (_) { /* noop */ }
}
